import { SegmentHeader } from "@/components/campaign/basic/SegmentHeader";
import { NumberField } from "@/components/generic/NumberField";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import z from "zod";

export const Route = createFileRoute(
  "/_dashboard/campaigns/setup/planning/lead-amount",
)({
  component: RouteComponent,
  staticData: {
    meta: {
      title: "Antal leads",
    },
  },
});

const formSchema = z.object({
  leadAmount: z
    .number()
    .nullable()
    .refine(
      (value) => value !== null && value >= 0 && value <= 1000,
      "Antal leads skal være mellem 0 og 1.000",
    ),
});

function RouteComponent() {
  const context = Route.useRouteContext();

  const stepper = context.useStepper();

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitted },
  } = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      leadAmount:
        stepper.context.planning?.type === "OnDemand"
          ? stepper.context.planning?.leadAmount
          : null,
    },
  });

  const submit = useMemo(
    () =>
      handleSubmit((data) => {
        stepper.setContext((prev) => {
          if (prev.planning?.type !== "OnDemand") return prev;
          return {
            ...prev,
            planning: {
              ...prev.planning,
              leadAmount: data.leadAmount,
            },
          };
        });
        stepper.goNext();
      }),
    [handleSubmit, stepper],
  );

  context.stepper.useStepperSubmit(
    useMemo(
      () => ({ submit: submit, isDisabled: !isValid && isSubmitted }),
      [submit, isValid, isSubmitted],
    ),
  );

  return (
    <form className="flex flex-col items-center gap-y-10" onSubmit={submit}>
      <SegmentHeader
        className="mx-auto max-w-lg"
        title="Antal leads"
        description="Angiv hvor mange leads du ønsker at modtage med det samme."
      />

      <NumberField
        className="w-full max-w-3xs"
        control={control}
        name="leadAmount"
        aria-label="Antal leads"
        placeholder="Antal leads"
        isRequired
        maxDecimals={0}
      />
    </form>
  );
}
